var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCharityRegulation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Love-Heart-Hands-Hold-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Love Heart Hands Hold 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 1h2s1 0 1 1v7s0 1 -1 1h-2s-1 0 -1 -1V2s0 -1 1 -1",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 14h2s1 0 1 1v7s0 1 -1 1H1s-1 0 -1 -1v-7s0 -1 1 -1",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 8.54a1 1 0 0 1 -1.4 0 2.52 2.52 0 0 0 -3.56 3.57L11.43 16a0.77 0.77 0 0 0 1.14 0l3.69 -3.84a2.52 2.52 0 0 0 -3.56 -3.62Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.66 2.07 -1.92 -0.66c-5.82 -2 -5.93 -2 -11.55 1 -1.28 0.66 -2.88 1.51 -4.91 2.52A0.49 0.49 0 0 0 0 5.3a0.46 0.46 0 0 0 0.14 0.43 3.21 3.21 0 0 0 3.5 1.13l2 -0.64A0.52 0.52 0 0 0 6 5.73a2.27 2.27 0 0 1 2.25 -2.29h5.25a0.5 0.5 0 0 1 0.5 0.5 0.5 0.5 0 0 1 -0.5 0.5H8.25a1.24 1.24 0 0 0 -0.6 2.33 4 4 0 0 1 1.88 -0.47 7.42 7.42 0 0 1 2.6 0.77 4 4 0 0 1 5.95 1.46c0.06 0.13 0.11 0.27 0.16 0.41h0.26a0.5 0.5 0 0 0 0.5 -0.5v-5.9a0.51 0.51 0 0 0 -0.34 -0.47Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 18.27a3.21 3.21 0 0 0 -3.49 -1.13l-2 0.64a0.52 0.52 0 0 0 -0.35 0.49 2.27 2.27 0 0 1 -2.25 2.29H10.5a0.5 0.5 0 0 1 -0.5 -0.5 0.5 0.5 0 0 1 0.5 -0.5h5.25a1.25 1.25 0 1 0 0 -2.5h-2.18a2.29 2.29 0 0 1 -1.57 0.64 2.33 2.33 0 0 1 -1.66 -0.7l-1.73 -1.8a4.83 4.83 0 0 0 -1.11 -0.13h-2a0.5 0.5 0 0 0 -0.5 0.5v5.9a0.51 0.51 0 0 0 0.34 0.47l1.92 0.66c5.82 2 5.93 2 11.55 -1 1.28 -0.68 2.88 -1.53 4.91 -2.54a0.49 0.49 0 0 0 0.28 -0.36 0.46 0.46 0 0 0 -0.15 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCharityRegulation);
export default ForwardRef;